import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import arrowBack from "./images/arrow.svg";
import { getCmsPageSection } from "../../../utils/helpers/get-cms-page-section";
import Modal from "../modal";
import ExploreInsurancePlanCard from "../explore-insurance-plan-card/component";
import { getMyBookingCarDetailsURL } from "../../../utils/helpers/get-detail-page-url";
import { tasksRoutes } from "../../../constants/au.mobile/tasks-routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HuddleIcon from "./images/huddle-logo.png";
// import { NUMBER } from "../../../constants/app-constants";
import { trackMobileCustomEventsAU } from "../../../tracking";
import { AU_MOBILE_EVENTS } from "../../../tracking/au.mobile-events";
import { HUDDLE_STATUS } from "../../au.mobile/post-payment-journey/constant";

const InsuranceCongratulationScreen = ({ isOpen, isSubmitLoading, cmsConfig, formData, appointmentId, setIsOpen }) => {
    // const [isSubmitLoading, setIsSubmitLoading] = useState(true);
    // const [hasThresholdTimePassed, setHasThresholdTimePassed] = useState(false);

    const history = useHistory();
    const { pageSections = [] } = cmsConfig || {};
    const CAR_INSURANCE_WEBSITE = getCmsPageSection("CAR_INSURANCE_WEBSITE", pageSections);
    const { pageSection } = CAR_INSURANCE_WEBSITE || {};
    const { meta = {} } = pageSection || {};
    const {huddleTransitionData = {}, huddleFallBackData = {}} = meta?.data || {};
    const {title = "", steps = [], redirectingSubTitle = "", redirectedSubTitle = ""} = huddleTransitionData || {};
    const { huddleLink = "", status = ""} = formData || {};
    const isInsuranceFailed = status === HUDDLE_STATUS.FAILED;
    // useEffect(() => {
    //     const thresholdTime = 0;
    //     const timer = window.setTimeout(() => {
    //         setHasThresholdTimePassed(true);
    //     }, thresholdTime);
    //     return () => window.clearTimeout(timer);
    // }, []);

    // useEffect(() => {
    //     if (huddleLink && hasThresholdTimePassed) {
    //         setIsSubmitLoading(false);
    //     }
    // }, [huddleLink, hasThresholdTimePassed]);

    useEffect(() => {
        if (!isSubmitLoading) {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_PAGE_LOADED, { eventLabel: "Intermidate_page_with_CTA" });
            if (!isInsuranceFailed) {
                window.open(huddleLink, "_blank");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [huddleLink, isSubmitLoading]);

    const handleNextStep = () => {
        setIsOpen(false);
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_INSURANCE_CTA, { eventLabel: "Intermediate_page_CTA" });
        const { relativeURL } = getMyBookingCarDetailsURL(appointmentId, tasksRoutes.viewTask.route, null, null);
        history.replace(relativeURL);
    };

    return (
        <Modal isOpen={isOpen}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.wrapper"}>
                    <div styleName={"styles.topSection"}>
                        {/* <img src={confettiImageUrl} /> */}
                        <img width={164} height={31} src={HuddleIcon}/>

                    </div>
                    <div styleName={"styles.sliderContainer"}>
                        <ExploreInsurancePlanCard key={1} heading={title} slideData={steps}  redirectingSubTitle={redirectingSubTitle} formData={formData} redirectedSubTitle={redirectedSubTitle} isSubmitLoading={isSubmitLoading} failedData={huddleFallBackData}/>

                    </div>
                </div>
            </div>
            {!isSubmitLoading && (
                <div onClick={handleNextStep} styleName={"styles.buttonContainer"}>
                    <button>Continue to next step <img src={arrowBack} /></button>
                </div>
            )}
        </Modal>
    );
};

InsuranceCongratulationScreen.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    cmsConfig: PropTypes.object.isRequired,
    formData: PropTypes.object.isRequired,
    appointmentId: PropTypes.string.isRequired,
    isSubmitLoading: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired
};

export default InsuranceCongratulationScreen;
